import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { rem } from '../../utilities/style';

import DropdownLink from './DropdownLink';

const DropdownItems = styled.ul`
  padding-top: ${rem(8)};
`;

const DropdownItem = styled.li`
  padding: ${rem(6)} 0;
`;

const DropdownMenuButtons = ({ items, buttonProps = [], onClick }) => (
  <DropdownItems role="menu">
    {items.map((item, index) => (
      <DropdownItem key={item.id || index} role="menuitem">
        <DropdownLink
          component="button"
          type="button"
          onClick={() => onClick(item)}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...buttonProps[index]}
        >
          {item.title}
        </DropdownLink>
      </DropdownItem>
    ))}
  </DropdownItems>
);

DropdownMenuButtons.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  buttonProps: PropTypes.arrayOf(PropTypes.object)
};

export default DropdownMenuButtons;
